export class Appointment {

    private active: boolean;
    private allowBeforeMilliseconds: number;
    private allowAfterMilliseconds: number;
    private appointmentChecked: boolean;
    private appointmentDate: number;
    private appointmentToken: string;
    private creationDate: number;
    private customerInternalId: string;
    private internalId: string;
    private originIdentifier: string;
    private turnDeskInternalId: string;
    private turnDeskName: string;
    private turnFormInternalId: string;
    private turnFormName: string;
    private userDni: string;
    private userMail: string;
    private userName: string;
    private userSurname: string;
    private userTelephone: string;
    private userLicensePlate: string;
    private userPassport: string;
    private userCard: string;
    private userDocumentUrl: string;

    constructor(active?: boolean, allowBeforeMilliseconds?: number, allowAfterMilliseconds?: number, appointmentChecked?: boolean, appointmentDate?: number, appointmentToken?: string, creationDate?: number, customerInternalId?: string, internalId?: string, originIdentifier?: string, turnDeskInternalId?: string, turnDeskName?: string, turnFormInternalId?: string, turnFormName?: string, userDni?: string, userMail?: string, userName?: string, userSurname?: string, userTelephone?: string, userLicensePlate?: string, userPassport?: string, userCard?: string, userDocumentUrl?: string) {
        this.active = active;
        this.allowBeforeMilliseconds = allowBeforeMilliseconds;
        this.allowAfterMilliseconds = allowAfterMilliseconds;
        this.appointmentChecked = appointmentChecked;
        this.appointmentDate = appointmentDate;
        this.appointmentToken = appointmentToken;
        this.creationDate = creationDate;
        this.customerInternalId = customerInternalId;
        this.internalId = internalId;
        this.originIdentifier = originIdentifier;
        this.turnDeskInternalId = turnDeskInternalId;
        this.turnDeskName = turnDeskName;
        this.turnFormInternalId = turnFormInternalId;
        this.turnFormName = turnFormName;
        this.userDni = userDni;
        this.userMail = userMail;
        this.userName = userName;
        this.userSurname = userSurname;
        this.userTelephone = userTelephone;
        this.userLicensePlate = userLicensePlate;
        this.userPassport = userPassport;
        this.userCard = userCard;
        this.userDocumentUrl = userDocumentUrl;
    }

    public set Active(active) {
        this.active = active;
    }
    public set AppointmentChecked(appointmentChecked) {
        this.appointmentChecked = appointmentChecked;
    }
    public set AppointmentDate(appointmentDate) {
        this.appointmentDate = appointmentDate;
    }
    public set AllowBeforeMilliseconds(allowBeforeMilliseconds) {
        this.allowBeforeMilliseconds = allowBeforeMilliseconds;
    }
    public set AllowAfterMilliseconds(allowAfterMilliseconds) {
        this.allowAfterMilliseconds = allowAfterMilliseconds;
    }
    public set AppointmentToken(appointmentToken) {
        this.appointmentToken = appointmentToken;
    }
    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }
    public set CustomerInternalId(customerInternalId) {
        this.customerInternalId = customerInternalId;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set OriginIdentifier(originIdentifier) {
        this.originIdentifier = originIdentifier;
    }
    public set TurnDeskInternalId(turnDeskInternalId) {
        this.turnDeskInternalId = turnDeskInternalId;
    }
    public set TurnDeskName(turnDeskName) {
        this.turnDeskName = turnDeskName;
    }
    public set TurnFormInternalId(turnFormInternalId) {
        this.turnFormInternalId = turnFormInternalId;
    }
    public set TurnFormName(turnFormName) {
        this.turnFormName = turnFormName;
    }
    public set UserDni(userDni) {
        this.userDni = userDni;
    }
    public set UserMail(userMail) {
        this.userMail = userMail;
    }
    public set UserName(userName) {
        this.userName = userName;
    }
    public set UserSurname(userSurname) {
        this.userSurname = userSurname;
    }
    public set UserTelephone(userTelephone) {
        this.userTelephone = userTelephone;
    }
    public set UserDocumentUrl(userDocumentUrl) {
        this.userDocumentUrl = userDocumentUrl;
    }
    public set UserLicensePlate(userLicensePlate) {
        this.userLicensePlate = userLicensePlate;
    }
    public set UserPassport(userPassport) {
        this.userPassport = userPassport;
    }
    public set UserCard(userCard) {
        this.userCard = userCard;
    }

    public get Active() {
        return this.active;
    }
    public get AppointmentChecked() {
        return this.appointmentChecked;
    }
    public get AppointmentDate() {
        return this.appointmentDate;
    }
    public get AppointmentToken() {
        return this.appointmentToken;
    }
    public get AllowBeforeMilliseconds() {
        return this.allowBeforeMilliseconds;
    }
    public get AllowAfterMilliseconds() {
        return this.allowAfterMilliseconds;
    }
    public get CreationDate() {
        return this.creationDate;
    }
    public get CustomerInternalId() {
        return this.customerInternalId;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get OriginIdentifier() {
        return this.originIdentifier;
    }
    public get TurnDeskInternalId() {
        return this.turnDeskInternalId;
    }
    public get TurnDeskName() {
        return this.turnDeskName;
    }
    public get TurnFormInternalId() {
        return this.turnFormInternalId;
    }
    public get TurnFormName() {
        return this.turnFormName;
    }
    public get UserDni() {
        return this.userDni;
    }
    public get UserMail() {
        return this.userMail;
    }
    public get UserName() {
        return this.userName;
    }
    public get UserSurname() {
        return this.userSurname;
    }
    public get UserTelephone() {
        return this.userTelephone;
    }
    public get UserDocumentUrl() {
        return this.userDocumentUrl;
    }
    public get UserLicensePlate() {
        return this.userLicensePlate;
    }
    public get UserPassport() {
        return this.userPassport;
    }
    public get UserCard() {
        return this.userCard;
    }
}
